import React, { FC } from 'react';
import { UserCycle } from '../../../common/model/dto/user-cycle/user-cycle';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import OvListTable from '../atoms/OvListTable';
import OvListTableHeaderField from '../atoms/OvListTableHeaderField';
import OvListTableRow from '../atoms/OvListTableRow';
import OvUserCyclesListRow from './OvUserCyclesListRow';

interface UserCycleListProps {
  userCycles: UserCycle[];
}

const UserCycleList: FC<UserCycleListProps> = ({ userCycles }) => {
  const { t } = useTranslation();

  const headerNames = [
    { name: 'userCycles.headers.cycleStart' },
    { name: 'userCycles.headers.cycleEnd' },
    { name: 'userCycles.headers.cycleLength' },
    { name: 'userCycles.headers.isOvulatoryCycle' },
    { name: 'userCycles.headers.createdAt' },
    { name: 'common.action' },
  ];

  return (
    <WrapperBox>
      <OvListTable>
        <OvListTableRow>
          {headerNames.map(({ name }) => (
            <OvListTableHeaderField style={{ cursor: 'pointer' }}>
              {t(name)}
            </OvListTableHeaderField>
          ))}
        </OvListTableRow>

        {userCycles.map((userCycle) => (
          <OvListTableRow key={userCycle.id}>
            <OvUserCyclesListRow userCycle={userCycle} />
          </OvListTableRow>
        ))}
      </OvListTable>
    </WrapperBox>
  );
};

export default UserCycleList;

const WrapperBox = styled.div`
  padding: 1.5rem 1rem 1rem;
  overflow-x: auto;
`;
